import type { SidebarContextProject, SidebarProjectSummary } from "@/ui/layoutUser";

export type ProjectSwitcherInput = {
  pathname: string;
  sidebarProjects?: SidebarProjectSummary[];
  sidebarContext?: {
    project?: Pick<SidebarContextProject, "id" | "siteIconUrl" | "previewUrl"> | null;
  };
};

const letterFromLabel = (label: string): string => {
  const t = label.trim();
  if (!t) return "?";
  const ch = t[0];
  return ch ? ch.toUpperCase() : "?";
};

export const deriveSelectedProjectId = (input: ProjectSwitcherInput): string | null => {
  const fromCtx = input.sidebarContext?.project?.id;
  if (fromCtx) return fromCtx;
  const m = input.pathname.match(/^\/projects\/([^/]+)/);
  if (m?.[1] && m[1] !== "new") return m[1];
  return null;
};

export const getProjectSwitcherTrigger = (
  input: ProjectSwitcherInput
): {
  href: string;
  label: string;
  letter: string;
  siteIconUrl: string | null;
  previewUrl: string | null;
} => {
  const list = input.sidebarProjects ?? [];
  const selectedId = deriveSelectedProjectId(input);
  const proj = selectedId ? list.find((p) => p.id === selectedId) : undefined;
  if (proj) {
    const ctx = input.sidebarContext?.project;
    const mergeIcons =
      ctx && ctx.id === proj.id
        ? {
            siteIconUrl: ctx.siteIconUrl ?? proj.siteIconUrl ?? null,
            previewUrl: ctx.previewUrl ?? proj.previewUrl ?? null
          }
        : { siteIconUrl: proj.siteIconUrl ?? null, previewUrl: proj.previewUrl ?? null };
    return {
      href: `/projects/${proj.id}`,
      label: proj.name,
      letter: letterFromLabel(proj.name),
      siteIconUrl: mergeIcons.siteIconUrl,
      previewUrl: mergeIcons.previewUrl
    };
  }
  if (input.pathname.startsWith("/projects/new")) {
    return { href: "/projects/new", label: "New project", letter: "N", siteIconUrl: null, previewUrl: null };
  }
  return { href: "/projects", label: "Projects", letter: "P", siteIconUrl: null, previewUrl: null };
};
